import { getUrlParams } from "@/utils";
import { HASH_KEYS, IMAGE_RESOURCE_DOMAIN, MODE_TYPE } from "@/utils/domain";

const NODE_ENV: MODE_TYPE = import.meta.env.VITE_USER_NODE_ENV as MODE_TYPE;

console.log("[MODE_TYPE]: ", NODE_ENV, JSON.stringify(import.meta.env));

// 获取ql用户平台类型
export const getPlatformType = () => {
	const ql_platform_type = getUrlParams("platform_type") as HASH_KEYS;
	return ql_platform_type;
};

// 获取资源类型uri等
export const getPlatformUrl = (ql_platform_type: HASH_KEYS) => {
	return IMAGE_RESOURCE_DOMAIN[ql_platform_type][NODE_ENV];
};
